// JS elimina un producto del carrito de compras

$(document).ready(function(){
    // variables
    var data = { updates: {} }

    // acciones
    $('body').on('click', '.js-cart-delete__action', function(event) {
        event.preventDefault()
        cartDelete($(this))
    })

    $('body').on('click', '.js-cart-delete__action-full', function(event) {
        event.preventDefault()
        cartDeleteMulti()
    })

    // funciones
    function cartDelete(action){
        data.updates[ action.data('cart-delete__key') ] = 0
        cartDeleteLine(data)
    }

    function cartDeleteMulti(){
        cart = JSON.parse(localStorage.atom_cart)

        cart.items.forEach(item => {
            data.updates[item.key] = 0
        })
        
        cartDeleteLine(data)
    }

    function cartDeleteLine(data){
        $.ajax({
            url: "/cart/update",
            type: "post",
            data: data,
            dataType: 'json',
            async: false,
            success: () => {
                window.location = '/cart'
            },
            error: err => {
                console.log(err)
            }
        }) 
    }

})
